import { ru as reactru } from '@ews/react-translations';

const ru = {
...reactru
}
export default ru
